import { createApi } from '@reduxjs/toolkit/query/react'
import axiosBaseQuery from 'api/axiosBaseQuery'

const reportApi = createApi({
  reducerPath: 'reportApi',
  baseQuery: axiosBaseQuery({
    baseUrl: process.env.REACT_APP_BASE_URL ?? ''
  }),
  tagTypes: ['Report'],
  endpoints: () => ({})
})

export default reportApi
